(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-volleyball/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-volleyball/assets/javascripts/status.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_volleyball = svs.themes.sport_volleyball || {};
  var logger = new svs.core.log.Logger('svs.themes.sport_volleyball');

  svs.themes.sport_volleyball.matchNotice = function (match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }

    var matchStatus;

    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;

      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 25:
        matchStatus = 'Inställd';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_volleyball.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!_.contains([8, 9, 10, 11, 12, 13, 14, 26, 27], status);
  };

  svs.themes.sport_volleyball.isFinished = function (status) {
    return !!_.contains([31, 32, 41], status);
  };

  svs.themes.sport_volleyball.isEnded = function (status) {
    return !!_.contains([25, 26, 28, 31, 32, 41], status);
  }; 


  svs.themes.sport_volleyball.subscribeMatch = function (params) {
    return svs.themes.isDateHoursDiff(params.time, -4) && !svs.themes.sport_volleyball.isEnded(params.status);
  };

  svs.themes.sport_volleyball.hasStarted = function (status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };
})(svs);
 })(window);